import * as React from "react";

import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    container: {
        width: "100%"
    },
});

export function Page(props: React.PropsWithChildren<any>) {
    const classes = useStyles();

    return (
        <Box
            className={classes.container}
            pt={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            flexGrow={1}>
            {props.children}
        </Box>
    )
}